@if (open) {
    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOpen]="open"
        [cdkConnectedOverlayHasBackdrop]="true"
        (backdropClick)="closeModal()">
        <div
          class="vms-modal fixed inset-0 flex items-center justify-center bg-slate-900/50 px-4 py-8"
          (click)="close.emit()"
        >
          <div
            class="w-full max-w-3xl max-h-[90vh] rounded-[28px] bg-white shadow-2xl overflow-y-auto"
            (click)="$event.stopPropagation()"
            role="dialog"
            aria-modal="true"
          >
            <div class="p-6 sm:p-8 relative">
                <button
                type="button"
                class="close-btn"
                (click)="close.emit()"
                aria-label="Close"
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                    />
                </svg>
                </button>
        
                <div class="min-w-0 mb-10">
                    <app-page-header
                        [title]="'MDA Settings'"
                        [subtitle]="'Customize how your brand appears'"
                    ></app-page-header>
                </div>
        
                @if (isLoadingSettings) {
                    <div class="size-full pt-8 flex items-center justify-center">
                        <div class="flex flex-col items-center gap-3">
                            <div
                            class="size-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
                            ></div>
                            <p class="text-sm font-medium text-slate-500 text-center">
                                Fetching form data...
                            </p>
                        </div>
                    </div>
                } @else {
                    <form class="w-full flex gap-3" [formGroup]="settingsForm" (ngSubmit)="submit()">
                        <div class="flex flex-col gap-2">
                            <input 
                                (change)="extractLogoImage($event)"
                                type="file" 
                                accept="image/*" 
                                class="absolute opacity-0 pointer-events-none" 
                                #logoField
                            >
                            @if (logoPreview) {
                                <div class="w-44 border-2 border-dashed rounded-lg overflow-hidden">
                                    <img [src]="logoPreview" alt="Logo" class="size-full object-contain">
                                </div>
                                <button 
                                    type="button"
                                    (click)="removeLogoImage()" 
                                    class="px-9 py-1 text-vms-primary-p3 text-sm border-2 border-vms-primary-p4 rounded-md text-nowrap">
                                    Remove Logo
                                </button>
                            } @else {
                                <div class="w-44 px-3 py-9 bg-[#F4F4F4] border-2 border-dashed rounded-lg flex items-center justify-center">
                                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M28.6579 8.1875C29.3967 8.18749 30.1216 8.38731 30.756 8.7658C31.3905 9.14428 31.9107 9.68733 32.2616 10.3374L33.2567 12.1802C33.6076 12.8303 34.1278 13.3733 34.7622 13.7518C35.3966 14.1303 36.1216 14.3301 36.8603 14.3301H40.9492C42.0353 14.3301 43.0769 14.7615 43.8449 15.5295C44.6128 16.2975 45.0443 17.3391 45.0443 18.4251V36.8529C45.0443 37.9389 44.6128 38.9805 43.8449 39.7485C43.0769 40.5165 42.0353 40.9479 40.9492 40.9479H8.1888C7.10273 40.9479 6.06113 40.5165 5.29316 39.7485C4.52519 38.9805 4.09375 37.9389 4.09375 36.8529V18.4251C4.09375 17.3391 4.52519 16.2975 5.29316 15.5295C6.06113 14.7615 7.10273 14.3301 8.1888 14.3301H12.2777C13.0157 14.3301 13.74 14.1307 14.3739 13.753C15.0079 13.3753 15.528 12.8333 15.8793 12.1843L16.8805 10.3333C17.2318 9.6843 17.7519 9.14228 18.3859 8.76456C19.0199 8.38684 19.7442 8.18746 20.4821 8.1875H28.6579Z" stroke="black" stroke-width="4.09505" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M24.569 32.7578C27.9615 32.7578 30.7116 30.0077 30.7116 26.6152C30.7116 23.2228 27.9615 20.4727 24.569 20.4727C21.1766 20.4727 18.4264 23.2228 18.4264 26.6152C18.4264 30.0077 21.1766 32.7578 24.569 32.7578Z" stroke="black" stroke-width="4.09505" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <button 
                                    type="button"
                                    (click)="selectLogoImage()" 
                                    class="px-9 py-1 text-vms-primary-p3 text-sm border-2 border-vms-primary-p4 rounded-md text-nowrap">
                                    Upload Logo
                                </button>
                            }
    
                            @if (settingsForm.get('logo')?.invalid && settingsForm.get('logo')?.touched) {
                                <div class="text-xs text-red-500">
                                @if (settingsForm.get('logo')?.hasError('required')) {
                                    <span>Logo is required.</span>
                                }
                                </div>
                            }
                        </div>
    
                        <div>
                            <!-- MDA Information -->
                            <div class="mb-3 grow grid grid-cols-2 gap-x-3 gap-y-6">
                                <div class="page-control-group">
                                    <label class="page-label">MDA</label>
                                    <div >
                                        <select 
                                            class="page-select"
                                            formControlName="mdaId"
                                        >
                                            <option value="" disabled>
                                                <p class="text-[#9AA0B3]">-- Select MDA --</p>
                                            </option>
                                            @for (mda of mdaOptions; track $index) {
                                                <option [value]="mda.id">{{ mda.name }}</option>
                                            }
                                        </select>
                                    </div>
                                    @if (settingsForm.get('mdaId')?.invalid && settingsForm.get('mdaId')?.touched) {
                                        <div class="text-xs text-red-500">
                                        @if (settingsForm.get('mdaId')?.hasError('required')) {
                                            <span>MDA is required.</span>
                                        }
                                        </div>
                                    }
                                </div>
                                <div class="page-control-group">
                                    <label class="page-label">Acronym</label>
                                    <input 
                                        [appCharLength]
                                        class="page-control"
                                        formControlName="acronym"
                                        placeholder="e.g. AWK"
                                    />
                                    @if (settingsForm.get('acronym')?.invalid && settingsForm.get('acronym')?.touched) {
                                        <div class="text-xs text-red-500">
                                        @if (settingsForm.get('acronym')?.hasError('required')) {
                                            <span>Acronym is required.</span>
                                        }
                                        </div>
                                    }
                                </div>
                                <div class="page-control-group">
                                    <label class="page-label">MDA Head Title</label>
                                    <input 
                                        [appCharLength]
                                        class="page-control"
                                        formControlName="headTitle"
                                        placeholder="e.g. Commissioner"
                                    />
                                    @if (settingsForm.get('headTitle')?.invalid && settingsForm.get('headTitle')?.touched) {
                                        <div class="text-xs text-red-500">
                                        @if (settingsForm.get('headTitle')?.hasError('required')) {
                                            <span>Head title is required.</span>
                                        }
                                        </div>
                                    }
                                </div>
                                <div class="page-control-group">
                                    <label class="page-label">Name of MDA head</label>
                                    <input 
                                        [appCharLength]
                                        class="page-control"
                                        formControlName="headName"
                                        placeholder="e.g. Ojii Onyedikachi"
                                    />
                                    @if (settingsForm.get('headName')?.invalid && settingsForm.get('headName')?.touched) {
                                        <div class="text-xs text-red-500">
                                        @if (settingsForm.get('headName')?.hasError('required')) {
                                            <span>Head name is required.</span>
                                        }
                                        </div>
                                    }
                                </div>
                
                                <div class="md:col-span-2">
                                    <label class="page-label">Upload MDA Head Signature</label>
                                    <input
                                        (change)="extractSignatureImage($event)" 
                                        type="file" 
                                        accept="image/*" 
                                        class="absolute opacity-0 pointer-events-none" 
                                        #signatureField>
                
                                    @if (signaturePreview) {
                                        <div 
                                            [class]="`mt-2 rounded-md cursor-pointer overflow-hidden object-contain transition-all duration-150
                                             ${isDraggingSignatureFile ? '!border-4 border-solid !border-vms-bg-secondary' : 'border-2 border-dashed border-[#E1E0E5]'}
                                            `"
                                            (click)="selectSignatureImage()"
                                            (drop)="onDrop($event)"
                                            (dragenter)="onDragEnter($event)"
                                            (dragover)="onDragOver($event)"
                                            (dragleave)="onDragLeave($event)"
                                        >
                                            <img [src]="signaturePreview" alt="Signature" class="w-full max-h-56">
                                        </div>
                                    } @else {
                                        <div 
                                            [class]="`p-4 mt-2 rounded-md flex flex-col items-center justify-center gap-2 cursor-pointer transition-all duration-150
                                             ${isDraggingSignatureFile ? '!border-4 border-solid !border-vms-bg-secondary' : 'border-2 border-dashed border-[#E1E0E5]'}
                                            `"
                                            (click)="selectSignatureImage()"
                                            (drop)="onDrop($event)"
                                            (dragenter)="onDragEnter($event)"
                                            (dragover)="onDragOver($event)"
                                            (dragleave)="onDragLeave($event)"
                                        >
                                            <svg class="size-16" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_949_7104)">
                                                    <mask id="mask0_949_7104" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="49" height="48">
                                                        <path d="M48.5078 0H0.507812V48H48.5078V0Z" fill="white"/>
                                                    </mask>
                                                    <g mask="url(#mask0_949_7104)">
                                                            <path d="M33.7194 40.0057C36.3994 40.0257 38.9794 39.0257 40.9594 37.2257C47.4994 31.5057 43.9994 20.0257 35.3794 18.9458C32.2994 0.265762 5.35946 7.34577 11.7395 25.1257" stroke="#5A6F8C" stroke-width="2.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M15.0666 25.9416C14.0066 25.4016 12.8266 25.1216 11.6466 25.1416C2.32657 25.8016 2.34657 39.3616 11.6466 40.0216" stroke="#5A6F8C" stroke-width="2.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M32.1406 19.7887C33.1806 19.2687 34.3006 18.9887 35.4606 18.9688" stroke="#5A6F8C" stroke-width="2.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <g opacity="0.4">
                                                            <path d="M26.4453 40H18.4453" stroke="#5A6F8C" stroke-width="2.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                            <path d="M22.4453 44V36" stroke="#5A6F8C" stroke-width="2.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </g>
                                                    </g>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_949_7104">
                                                        <rect width="48" height="48" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            <div>
                                                <p class="mb-2 text-xs text-vms-primary-p3 font-medium">Drag & drop or <span class="text-vms-primary-p2">Browse</span></p>
                                                <p class="text-[10px] text-vms-primary-p3 font-normal">PDF, JPG, PNG up to 10MB</p>
                                            </div>
                                        </div>
                                    }
                                    @if (settingsForm.get('headSignature')?.invalid && settingsForm.get('headSignature')?.touched) {
                                        <div class="text-xs text-red-500">
                                        @if (settingsForm.get('headSignature')?.hasError('required')) {
                                            <span>Head signature is required.</span>
                                        }
                                        </div>
                                    }
                                </div>
        
                            </div>
        
                            <!-- Brand Color -->
                            <div>
                                <p class="mb-2 text-vms-text-dark text-lg font-bold">Brand Color</p>
                                <div class="grow grid grid-cols-2 gap-x-3 gap-y-4">
                                    <div>
                                        <p class="mb-1 text-vms-text-1 text-sm font-normal">Primary Color</p>
                                        <div class="p-2 border border-[#D1D1D1A6] rounded-md flex items-center gap-3">
                                            <input 
                                                type="color" 
                                                [defaultValue]="settingsForm.get('primaryColor').value"
                                                class="h-10 border-none border-transparent rounded-md overflow-hidden cursor-pointer"
                                                formControlName="primaryColor">
                                            <p>{{ settingsForm.get('primaryColor').value }}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="mb-1 text-vms-text-1 text-sm font-normal">Primary Text Color</p>
                                        <div class="p-2 border border-[#D1D1D1A6] rounded-md flex items-center gap-3">
                                            <input 
                                                type="color" 
                                                [defaultValue]="settingsForm.get('primaryTextColor').value"
                                                class="h-10 border-none border-transparent rounded-md overflow-hidden cursor-pointer"
                                                formControlName="primaryTextColor">
                                            <p>{{ settingsForm.get('primaryTextColor').value }}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="mb-1 text-vms-text-1 text-sm font-normal">Secondary Color</p>
                                        <div class="p-2 border border-[#D1D1D1A6] rounded-md flex items-center gap-3">
                                            <input 
                                                type="color" 
                                                [defaultValue]="settingsForm.get('secondaryColor').value"
                                                class="h-10 border-none border-transparent rounded-md overflow-hidden cursor-pointer"
                                                formControlName="secondaryColor">
                                            <p>{{ settingsForm.get('secondaryColor').value }}</p>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="mb-1 text-vms-text-1 text-sm font-normal">Secondary Text Color</p>
                                        <div class="p-2 border border-[#D1D1D1A6] rounded-md flex items-center gap-3">
                                            <input 
                                                type="color" 
                                                [defaultValue]="settingsForm.get('secondaryTextColor').value"
                                                class="h-10 border-none border-transparent rounded-md overflow-hidden cursor-pointer"
                                                formControlName="secondaryTextColor">
                                            <p>{{ settingsForm.get('secondaryTextColor').value }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <button 
                                type="submit" 
                                [disabled]="isSubmitting || !isFormValid"
                                class="page-btn page-btn-primary w-full mt-4 p-3 gap-2">
                                @if (isSubmitting) {
                                    <div class="flex items-center gap-2">
                                        <span
                                            class="inline-block size-6 animate-spin rounded-full border-4 border-slate-400/40 border-t-white"
                                            aria-hidden="true"></span>
                                        <p>
                                            Submitting...
                                        </p>
                                    </div>
                                } @else {
                                    <p>Save & Update</p>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                        <path d="M2.91406 6.9974H11.0807M6.9974 11.0807L11.0807 6.9974L6.9974 2.91406" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                }
                            </button>
                        </div>
                    </form>
                }
            </div>
          </div>
        </div>
    </ng-template>
}

